import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { JobsServiceProvider } from '../../api/jobs'

const JobsService = JobsServiceProvider()
const nameJob = 'addJob'

export default (data) => (asyncAction(
  nameJob,
  JobsService.addJob,
  data
))

export const reducer = asyncReducer(nameJob)
export const selector = asyncSelector(nameJob)



// WEBPACK FOOTER //
// ./src/store/jobs/addJob.js